import { regonMessage, requiredMessage } from "../validationMessages";
import { regonValidator as regonValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

export const regonValidator = trimmedString.matches(regonValidatorRegex, {
  message: regonMessage,
  excludeEmptyString: true,
});
export const regonValidatorRequired = trimmedString
  .required(requiredMessage)
  .matches(regonValidatorRegex, regonMessage);
